module.exports = __webpack_public_path__ + "static/media/privacy_footer_active.1cf9d4dc.svg";